export default __webpack_public_path__ + "static/media/mini_big.eec1a4ed.png";